<template>
<v-btn :block="phoneOnly" depressed @click="load" color="primary" large rounded min-width="250px">
    <v-icon left>mdi-message-processing-outline</v-icon>
    <strong>ابدأ المحادثة</strong>
</v-btn>
</template>

<script>
import { Crisp } from "crisp-sdk-web";

export default {
    props: {
        user: {required: true},
        websiteId: {required: true}
    },
    data(){
        return {
            Crisp: null,
        }
    },
    computed: {
        pcOnly(){
            return this.$vuetify.breakpoint.mdAndUp;
        },
        mdAndUp(){
            return this.$vuetify.breakpoint.smAndUp;
        },
        phoneOnly(){
            return !this.pcOnly;
        },
    },
    methods: {
        load(){
            // this.Crisp.load();
            this.Crisp.chat.show();
            this.Crisp.chat.open();
        }
    },
    mounted(){
        this.Crisp = Crisp;
        if (this.user){
            this.Crisp.user.setEmail(this.user.email);
            this.Crisp.user.setCompany('Profile', {url: process.env.VUE_APP_PRODUCTION_API_URL.replace('api.', 'dashboard.').replace('/v1', `/users/${this.user.id}`), description: 'Profile URL'})
            this.Crisp.user.setAvatar(this.user.avatar);
            this.Crisp.user.setNickname(this.user.name);
            
            this.Crisp.session.setData({
                user_id : this.user.id,
                phone : this.user.phone,
            });
        }


        this.Crisp.configure(this.websiteId, {
            autoload: false,
            locale: 'ar',
        });
        this.Crisp.chat.onChatClosed(()=>{
            this.Crisp.chat.hide();
        })

        this.Crisp.chat.hide();
    },
    beforeDestroy(){
        if (this.Crisp){
            this.Crisp.chat.close();
            this.Crisp.chat.hide();
        }
    }
}
</script>
